import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import type { LeadData } from "./types";
import { LeadForm } from "./LeadForm";

export function CTASection({ onCta, onSubmit }: { onCta: () => void; onSubmit: (d: LeadData) => void }) {
  return (
    <section id="kontakt-cta" className="text-primary-foreground" style={{ background: "var(--gradient-hero)" }}>
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col justify-center text-center lg:text-left">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Handeln Sie jetzt, bevor es zu spät ist.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-white/75 lg:mx-0">
            Zeit ist bei Anlagebetrug ein kritischer Faktor. Je früher die Gelder
            verfolgt werden, desto höher ist die Chance auf eine Sicherstellung.
          </p>
          {/* <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row lg:justify-start">
            <Button variant="gold" size="lg" onClick={onCta}>
              Kostenlose Beratung anfordern <ArrowRight className="h-4 w-4" />
            </Button>
          </div> */}
        </div>

        <div className="w-full max-w-md justify-self-center lg:justify-self-end">
          <LeadForm onSubmit={onSubmit} idPrefix="cta" />
        </div>
      </div>
    </section>
  );
}